module.exports = __webpack_public_path__ + "static/media/loading-truck-body1.5f2cdcc1.svg";